import React from 'react';
import StatsElement from '../../../../shared/entities/stats-element/components/StatsElement';
import { StatsElementType } from '../../../../shared/entities/stats-element/enums/StatsElementType';
import AdditionalStatsContentContainer from '../../shared/components/AdditionalStatsContentContainer';
import AdditionalStatsPage from '../AdditionalStatsPage';

const US_LARGEST_IPOS_FOOTNOTE =
  'Deal size amounts do not reflect any exercise of the underwriter overallotment (greenshoe). ' +
  'All deal sizes are nominal amounts without adjustment for inflation.';

const LargestUSIPOs: React.FC = () => {
  return (
    <AdditionalStatsPage>
      <AdditionalStatsContentContainer title="Largest US IPOs">
        <StatsElement
          type={StatsElementType.LargestIPOsUs}
          options={{ viewGridOptions: { 0: { footnote: US_LARGEST_IPOS_FOOTNOTE } } }}
        />
      </AdditionalStatsContentContainer>
    </AdditionalStatsPage>
  );
};

export default LargestUSIPOs;
